import { useMemo } from "react";
import { get } from "lodash";

import { getTeamProfileImageUrl } from "src/util/group";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import { teamDetailsPath } from "src/util/routing";
import { getTeamGradient } from "src/util/gradient";
import { useOrgBranding } from "src/hooks/orgConfig/hooks/useOrgBranding";

const useUserTeams = () => {
  const { branding } = useOrgBranding();
  const userPerson = useUserPerson();

  const userTeams = useMemo(() => {
    return userPerson?.memberOf?.map((team) => ({
      name: team.name,
      avatar: getTeamProfileImageUrl(get(team, "attributes")),
      link: teamDetailsPath(team),
      shape: "square",
      gradient: getTeamGradient(branding, team),
      type: team.type,
    }));
  }, [userPerson, branding]);

  return {
    userTeams,
  };
};

export default useUserTeams;
